import React, { Component } from 'react'
import "../HeaderSection/InnerHeaderBranding.css"
import { Link, withRouter } from "react-router-dom";

class InnerHeaderBranding extends Component {
    constructor(props){
        super(props)
        this.state = {
            isSignIn: false,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState){
         if(nextProps.location.pathname == "/")
         return { isSignIn: false};
         else
         return { isSignIn: true};
        
     }
    render() {
        return (
            <div className="in-header-wrap ihb">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                        <h1><Link className="in-header-link ihb" to={this.state.isSignIn ?"/Admin":"/"}>NJ Transit Rewards Program</Link></h1>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}

export default  withRouter(InnerHeaderBranding)
